import { envTypes } from "utils/const";

const localServer = import.meta.env.VITE_API_LOCAL || "http://localhost:4002";
const _stagingServer = import.meta.env.VITE_API_STAGING || "https://staging-api.organizedroofer.net";
const prodServer = import.meta.env.VITE_API_PRODUCTION || "https://api.organizedroofer.net";
const uatServer = import.meta.env.VITE_API_UAT || "https://uat-api.organizedroofer.net";

const getBaseUrl = () => {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  const env = import.meta.env.VITE_APP_ENV;
  switch (env) {
    case envTypes.development:
    case "development":
      return localServer;
    case "staging":
      return uatServer;
    case "production":
      return prodServer;
    default:
      return uatServer; // UAT as fallback
  }
};

export default {
  appName: "Organised Roofers",
  baseUrl: getBaseUrl(),
  dbName: "adminDB",
  dbColName: "admin",
  axiosTimeout: 300000,
  dbUserId: "OR:ADMIN",
};

